import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const ReactionThumbsDownColorIcon = (props: IconProps) => (
  <Icon width="17px" height="16px" viewBox="0 0 17 16" {...props}>
    <circle cx="8.208" cy="8" r="8" fill="#007AFF" />
    <path
      fill="#fff"
      d="M9.54 4.334h-4a.883.883 0 0 0-.817.542L3.38 8.01a.878.878 0 0 0-.063.324v.889c0 .489.4.889.89.889h2.804l-.423 2.03-.013.143c0 .182.076.351.196.471l.47.467 2.93-2.929a.883.883 0 0 0 .258-.627V5.223c0-.489-.4-.889-.89-.889Zm1.778 0v5.333h1.778V4.334h-1.778Z"
    />
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M2.874 3h10.667v10.667H2.874z" />
      </clipPath>
    </defs>
  </Icon>
);

export default memo(ReactionThumbsDownColorIcon);
